//该文件为获取码表本地数据，优先查本地缓存，若无缓存，则重新获取数据
import localForage from 'localforage'

import { getCodeTableList } from '@/api'

export const getCodeTable = async params => {
  const { codeDefId } = params
  let codeKey = `1|${codeDefId}`
  let value = await localForage.getItem(codeKey)
  let lang = localStorage.getItem('lang') || 'zh-CN'
  //根据lang区分是否储存的是当前语言版本
  if (!value || !value[lang]) {
    // indexdb无值
    // 重新获取数据
    try {
      value = await getCodeTableList(params)
      // indexdb存储完毕后，同步返回数据
      // 不必储存多套语言缓存，占用空间。所以可以直接替换掉码表缓存内容
      localForage.setItem(codeKey, { [lang]: value.data })
      return value.data
    } catch (error) {
      console.log(error)
    }
  } else {
    // console.log('获取本地数据', codeKey, value[lang])

    // indexdb有值,直接返回Promise

    return value[lang]
  }
}
